import React, { useEffect, useContext } from "react";
import { useTranslation } from 'react-i18next';
import useForm from 'react-hook-form';
import ReactTable from "react-table";

// core components
import GridContainer from "beaktShared/components/Grid/GridContainer.js";
import GridItem from "beaktShared/components/Grid/GridItem.js";
import Card from "beaktShared/components/Card/Card";
import CardBody from "beaktShared/components/Card/CardBody.js";
import CardHeader from "beaktShared/components/Card/CardHeader.js";
import CardIcon from "beaktShared/components/Card/CardIcon.js";
import Button from "beaktShared/components/CustomButtons/Button.js";
import SnackbarContent from "beaktShared/components/Snackbar/SnackbarContent.js";

// @material-ui/core components
import FormControl from "@material-ui/core/FormControl";
import FormHelperText from "@material-ui/core/FormHelperText";
import TextField from '@material-ui/core/TextField';
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import Slide from "@material-ui/core/Slide";

// icons
import Assignment from '@material-ui/icons/Assignment';
import Close from "@material-ui/icons/Close";

// services
import { SessionContext } from "beaktShared/services/session";
import { UseGetApiSimple, UsePostApi } from "beaktShared/services/crudeApiService";

import { ValidSelect } from "beaktShared/helpers/validselect";
import Select from 'react-select';

// styles
import { makeStyles } from "@material-ui/core/styles";
import styles from "assets/jss/material-dashboard-pro-react/views/regularFormsStyle";
import { noCaseSensitive } from "beaktShared/helpers/extras";
import { formateDateandTime, MaskMonthYear, MaskDecimal, MaskInt, transformValueFormatedtoFloat, transformValueFloattoFormated } from "beaktShared/helpers/masks";


const useStyles = makeStyles(styles);

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="down" ref={ref} {...props} />;
});

export default function ParcelamentoRoyalties() {
    const { t } = useTranslation();
    const session = useContext(SessionContext);
    const classes = useStyles();

    const { register, errors, setValue, clearError, getValues, setError } = useForm({ mode: "onChange" });

    const [isLoadingEstabelecimento, setisLoadingEstabelecimento] = React.useState(false);
    const [estabelecimentos, setestabelecimentos] = React.useState([]);
    const [estabelecimento, setestabelecimento] = React.useState(0);
    const [list, setlist] = React.useState([]);
    const [loading, setloading] = React.useState(false);
    const [loadingSalvar, setloadingSalvar] = React.useState(false);
    const [showModalNovo, setShowModalNovo] = React.useState(false);

    const [showFormView, setshowFormView] = React.useState(false);
    const [estabelecimentoNovo, setestabelecimentoNovo] = React.useState("");

    const [notification, setNotification] = React.useState({
        show: false,
        color: 'info',
        message: ''
    });

    const showNotification = (message, color) => {
        setNotification({
            show: true,
            color: color,
            message: message
        });
        setTimeout(function () {
            setNotification({ show: false });
        }, 6000);
    };

    const LoadEstabelecimentos = () => {
        setisLoadingEstabelecimento(true);
        const endPoint = "estabelecimentos/ativos/byfranquia/" + session.franquiaId;
        UseGetApiSimple(endPoint, 0).then(result => {
            if (result.status !== 200) {
                setisLoadingEstabelecimento(false);
                return false;
            }

            let lista = [];
            lista = [{ estabelecimentoId: 0, descricao: "Selecione..." }, ...result.data];

            setisLoadingEstabelecimento(false);
            setestabelecimentos(lista);
            return true;
        });
    };

    useEffect(() => {
        LoadEstabelecimentos();
    }, []);

    const handleEstabelecimentoChange = event => {
        let value = event;
        setestabelecimento(value);
        setValue("estabelecimento", value);
        if (value !== "")
            clearError("estabelecimento");
            
        handleClickPesquisa(value);
    };

    const handleEstabelecimentoNovoChange = event => {
        let value = event;
        setestabelecimentoNovo(value);
        setValue("novo_estabelecimento", value);
        if (value !== "")
            clearError("novo_estabelecimento");
    };

    const handleClickPesquisa = (estId) => {
        setloading(true);
        let estabId = estId !== undefined ? (estId || 0) : (estabelecimento || 0);

        UseGetApiSimple("ParcelamentoRoyalties/byestabelecimento/" + estabId, 0).then(result => {
            setloading(false);
            if (result.status !== 200) {
                showNotification(result.message, 'danger');
                return false;
            }
            if (result.data.length === 0) {
                showNotification(t('information_message.no_records_found') || 'Nenhum registro encontrado', 'warning');
            }
            setlist(result.data);
        });
    };

    const handleNovo = () => {
        let estId = estabelecimento > 0 ? estabelecimento : "";
        setValue("novo_estabelecimento", estId);
        setestabelecimentoNovo(estId);
        setValue("novo_mesAno", "");
        setValue("novo_valor", "");
        setValue("novo_parcelas", "");
        clearError("novo_estabelecimento");
        clearError("novo_mesAno");
        clearError("novo_valor");
        clearError("novo_parcelas");

        setshowFormView(true);
    };

    const handleSalvarNovo = () => {
        let est = estabelecimentoNovo;
        let formValues = getValues();
        let m = formValues.novo_mesAno;
        let v = formValues.novo_valor;
        let p = formValues.novo_parcelas;

        let hasError = false;
        if (!est || est === 0) { setError("novo_estabelecimento", "required", t('label.required')); hasError = true; }
        if (!m || m.length < 7) { setError("novo_mesAno", "required", t('label.required')); hasError = true; }
        if (!v) { setError("novo_valor", "required", t('label.required')); hasError = true; }
        if (!p) { setError("novo_parcelas", "required", t('label.required')); hasError = true; }

        if (hasError) return;

        let dto = {
            FranquiaId: session.franquiaId,
            EstabelecimentoId: est,
            UsuarioId: session.id,
            MesAnoReferencia: m,
            Valor: typeof v === 'string' ? transformValueFormatedtoFloat(v) : parseFloat(v),
            Parcelas: parseInt(p)
        };

        setloadingSalvar(true);

        UsePostApi("ParcelamentoRoyalties", dto).then(result => {
            setloadingSalvar(false);
            if (result.status !== 200 && result.status !== 201) {
                let msg = "Erro ao salvar";
                if (result.message) {
                    msg = result.message.message ? result.message.message : result.message;
                }
                showNotification(msg, 'danger');
                return false;
            }
            showNotification(t('information_message.registered_successfully') || "Cadastrado com sucesso!", "success");
            setestabelecimento(est);
            setshowFormView(false);

            setloading(true);
            UseGetApiSimple("ParcelamentoRoyalties/byestabelecimento/" + est, 0).then(res => {
                setloading(false);
                if (res.status === 200) {
                    setlist(res.data);
                }
            });
        });
    };

    let columns = [
        {
            Header: "Mês/Ano",
            accessor: "mesAnoReferencia",
        },
        {
            Header: "Valor",
            accessor: "valor",
            Cell: (props) => {
                if (props.value == null) return "";
                let valor = transformValueFloattoFormated(props.value);
                return valor;
            }
        },
        {
            Header: "Parcelas",
            accessor: "parcelas",
        },
        {
            Header: "Status",
            accessor: "statusParcelamentoRoyaltie",
            Cell: (props) => {
                if (props.value == null) return "";
                if (props.value === 0 || props.value === "0") return "Ativo";
                if (props.value === 1 || props.value === "1") return "Cancelado";
                if (props.value === 2 || props.value === "2") return "Finalizado";
                return props.value;
            }
        },
        {
            Header: "Data Cadastro",
            accessor: "dataCadastro",
            Cell: (props) => {
                if (props.value == null) return "";
                return formateDateandTime(props.value);
            }
        },
        {
            Header: "Usuário",
            accessor: "nomeUsuario",
        }
    ];

    return (
        <>
            <div className="maxContent">
                <form className="no-print">

                    {showFormView &&
                        <GridContainer>
                            <GridItem xs={12} sm={12} md={12}>
                                <Card>
                                    <CardHeader color="primary" icon>
                                        <CardIcon color="primary">
                                            <Assignment />
                                        </CardIcon>
                                        <h4 className={classes.cardIconTitle}>
                                            Novo Parcelamento de Royalties
                                        </h4>
                                    </CardHeader>
                                    <CardBody>
                                        <GridContainer>
                                            <GridItem xs={12} sm={12} md={12}>
                                                <FormControl fullWidth className={classes.formControl}>
                                                    <label className={errors.novo_estabelecimento ? "select__label select__label_error" : "select__label"}>
                                                        {t('label.establishment')} *</label>
                                                    <Select
                                                        classNamePrefix="select"
                                                        styles={ValidSelect(errors.novo_estabelecimento ? true : false)}
                                                        isSearchable={true}
                                                        isLoading={isLoadingEstabelecimento}
                                                        name="novo_estabelecimento"
                                                        placeholder={t('label.select') + "..."}
                                                        options={estabelecimentos.filter(e => e.estabelecimentoId !== 0)}
                                                        value={estabelecimentos.filter(({ estabelecimentoId }) => estabelecimentoId === estabelecimentoNovo)}
                                                        getOptionLabel={({ descricao }) => descricao}
                                                        getOptionValue={({ estabelecimentoId }) => estabelecimentoId}
                                                        onChange={(value) => handleEstabelecimentoNovoChange(value ? value.estabelecimentoId : "")}
                                                        ref={() => register({ name: "novo_estabelecimento" })}
                                                    />
                                                    {errors.novo_estabelecimento &&
                                                        <FormHelperText>
                                                            <span className="obg"> {t('label.required')} </span>
                                                        </FormHelperText>}
                                                </FormControl>
                                            </GridItem>
                                            <GridItem xs={12} sm={4} md={4}>
                                                <FormControl fullWidth className={classes.formControl}>
                                                    <TextField
                                                        error={errors.novo_mesAno ? true : false}
                                                        variant="outlined"
                                                        inputRef={register({ required: true })}
                                                        label={"Mês/Ano *"}
                                                        name="novo_mesAno"
                                                        InputProps={{ inputComponent: MaskMonthYear }}
                                                        InputLabelProps={{ shrink: true }}
                                                    />
                                                    {errors.novo_mesAno && <FormHelperText><span className="obg"> {t('label.required')}</span></FormHelperText>}
                                                </FormControl>
                                            </GridItem>
                                            <GridItem xs={12} sm={4} md={4}>
                                                <FormControl fullWidth className={classes.formControl}>
                                                    <TextField
                                                        error={errors.novo_valor ? true : false}
                                                        variant="outlined"
                                                        inputRef={register({ required: true })}
                                                        label={"Valor *"}
                                                        name="novo_valor"
                                                        InputProps={{ inputComponent: MaskDecimal }}
                                                        InputLabelProps={{ shrink: true }}
                                                    />
                                                    {errors.novo_valor && <FormHelperText><span className="obg"> {t('label.required')}</span></FormHelperText>}
                                                </FormControl>
                                            </GridItem>
                                            <GridItem xs={12} sm={4} md={4}>
                                                <FormControl fullWidth className={classes.formControl}>
                                                    <TextField
                                                        error={errors.novo_parcelas ? true : false}
                                                        variant="outlined"
                                                        inputRef={register({ required: true })}
                                                        label={"Parcelas *"}
                                                        name="novo_parcelas"
                                                        InputProps={{ inputComponent: MaskInt }}
                                                        InputLabelProps={{ shrink: true }}
                                                    />
                                                    {errors.novo_parcelas && <FormHelperText><span className="obg"> {t('label.required')}</span></FormHelperText>}
                                                </FormControl>
                                            </GridItem>
                                        </GridContainer>
                                        <GridContainer>
                                            <GridItem xs={12} sm={12} md={12} className={classes.textCenter}>
                                                <br />
                                                <div className={classes.textCenter}>
                                                    <Button color="transparent" onClick={() => setshowFormView(false)} >
                                                        {t('label.return')}
                                                    </Button>
                                                    <Button onClick={() => handleSalvarNovo()} color="primary" disabled={loadingSalvar}>
                                                        {t('button.to_save')} {loadingSalvar && <div> ... {t('label.loading')}</div>}
                                                    </Button>
                                                </div>
                                            </GridItem>
                                        </GridContainer>

                                        <GridItem md={12}>
                                            {
                                                notification.show &&
                                                <div>
                                                    <br />
                                                    <SnackbarContent
                                                        message={notification.message}
                                                        color={notification.color}
                                                        closeNotification={() => setNotification({ show: false })}
                                                        close
                                                    />
                                                </div>
                                            }
                                        </GridItem>
                                    </CardBody>
                                </Card>
                            </GridItem>
                        </GridContainer>
                    }

                    {!showFormView &&
                        <GridContainer>
                            <GridItem xs={12} sm={12} md={12}>
                                <Card>
                                    <CardHeader color="primary" icon>
                                        <CardIcon color="primary">
                                            <Assignment />
                                        </CardIcon>
                                        <h4 className={classes.cardIconTitle}>
                                            {t('sidebar.royalties_installments')}
                                        </h4>
                                    </CardHeader>
                                    <CardBody>
                                        <GridContainer>
                                            <GridItem xs={12} sm={10} md={10}>
                                                <FormControl fullWidth className={classes.formControl}>
                                                    <label className={errors.estabelecimento ? "select__label select__label_error" : "select__label"}>
                                                        {t('label.establishment')}</label>
                                                    <Select
                                                        classNamePrefix="select"
                                                        styles={ValidSelect(errors.estabelecimento ? true : false)}
                                                        isSearchable={true}
                                                        isLoading={isLoadingEstabelecimento}
                                                        name="estabelecimento"
                                                        placeholder={t('label.all') + "..."}
                                                        options={estabelecimentos}
                                                        value={estabelecimentos.filter(({ estabelecimentoId }) => estabelecimentoId === estabelecimento)}
                                                        getOptionLabel={({ descricao }) => descricao}
                                                        getOptionValue={({ estabelecimentoId }) => estabelecimentoId}
                                                        onChange={(value) => handleEstabelecimentoChange(value ? value.estabelecimentoId : "")}
                                                        ref={() => register({ name: "estabelecimento" })}
                                                    />
                                                    {errors.estabelecimento &&
                                                        <FormHelperText>
                                                            <span className="obg"> {t('label.required')} </span>
                                                        </FormHelperText>}
                                                </FormControl>
                                            </GridItem>
                                            <GridItem xs={12} sm={2} md={2}>
                                                <Button
                                                    color="primary"
                                                    className={classes.newButton}
                                                    onClick={() => handleNovo(true)}
                                                >
                                                    {t('button.new')}
                                                </Button>
                                            </GridItem>

                                            <GridItem md={12}>
                                                {
                                                    notification.show &&
                                                    <div>
                                                        <br />
                                                        <SnackbarContent
                                                            message={notification.message}
                                                            color={notification.color}
                                                            closeNotification={() => setNotification({ show: false })}
                                                            close
                                                        />
                                                    </div>
                                                }
                                            </GridItem>
                                        </GridContainer>

                                        <GridContainer>
                                            <br />
                                            <GridItem xs={12} sm={12} md={12}>
                                                <ReactTable
                                                    loading={loading}
                                                    data={list}
                                                    columns={columns}
                                                    filterable
                                                    defaultFilterMethod={noCaseSensitive}
                                                    defaultPageSize={10}
                                                    minRows={5}
                                                    showPaginationBottom={true}
                                                    className="-striped -highlight"
                                                    previousText={t('button.previous')}
                                                    nextText={t('button.next')}
                                                    loadingText={t('label.loading') + "..."}
                                                    noDataText={t('information_message.no_records_found') || "Nenhum registro encontrado!"}
                                                    pageText={t('label.page')}
                                                    ofText={t('label.of')}
                                                    rowsText={t('label.rows')}
                                                />
                                            </GridItem>
                                        </GridContainer>
                                    </CardBody>
                                </Card>
                            </GridItem>
                        </GridContainer>
                    }
                </form>
            </div>
        </>
    )
}
